import 'whatwg-fetch'
import { HOST, SERVERS, DRIVERS, DEVICES, CHANNELS, USERS, SYSTEMS, JOLOKIA } from './constants'
import { auth } from '.'

const encode = (url, params) => {
  const encoded = Object.keys(params).reduce( (r, k) => {
    const v = params[k]
    if (v) r.push(encodeURIComponent(k) + "=" + encodeURIComponent(v))
    return r
  }, [])
  return url + '?' + encoded.join('&')
}

const getHeader = () => {
  const headers = new Headers()
  headers.append('Content-Type', 'application/json; charset=UTF-8')
  headers.append('Authorization', auth.getBasicAuth())
  return headers
}

const checkStatus = (response) => {
//  console.log('status code => ' + response.status)
  if (response.status >= 200 && response.status < 300) {
    return response.json()
  }
  throw new Error(response)
}

const get = url => {
  return fetch(url, { headers: getHeader() })
  .then(checkStatus)
  .catch(e => {
    console.log(e)
//    throw new Error('Network error, '+e)
  })
}

const post = (url, data) => {
  return fetch(url, {
    method: 'POST',
    headers: getHeader(),
    body: data === null ? '' : data,
  })
  .then(checkStatus)
  .catch(e => console.log(e))
}

const httpUpload = (url, file, cb) => {
  return new Promise( (resolve, reject) => {
    const http = new XMLHttpRequest()
    http.open('POST', url, true)
    http.setRequestHeader('Content-Type', 'application/octet-stream')
    http.setRequestHeader('Authorization', auth.getBasicAuth())
    http.onload = e => resolve(JSON.parse(e.currentTarget.response))
    http.onerror = e => reject({status: e.status, statusText: e.statusText})
    if (http.upload && cb) http.upload.onprogress = cb
    http.send(file)
  })
}

export default {
  get:           (url)    => get(url),
  post:          (url, d) => post(url, d),

  system:         ()      => get(SYSTEMS+'system'),
  interfaces:     ()      => get(SYSTEMS+'interfaces'),
  memory:         ()      => get(SYSTEMS+'memory'),
  storage:        ()      => get(SYSTEMS+'storage'),
  javainfo:       ()      => get(SYSTEMS+'java'),
  user:           ()      => get(SYSTEMS+'user'),

  getSite:        ()      => get(SYSTEMS+'getsite'),
  setSite:        (d)     => post(SYSTEMS+'setsite', d),
  eventAll:       ()      => get(HOST+'/rest/event/list'),
  eventLatest:    ()      => get(HOST+'/rest/event/latest'),

  userList:       ()      => get(USERS+'listall'),
  userCreate:     (d)     => post(USERS+'add', d),
  userUpdate:     (d)     => post(USERS+'update', d),
  userRemove:     (d)     => post(USERS+'remove', d),
  userChange:     (d)     => post(USERS+'changepassword', d),

  serverList:     ()      => get(SERVERS+'list'),

  driverConfig:   (id)    => get(DRIVERS+'config/'+id),
  driverInfo:     (id)    => get(DRIVERS+'info/'+id),
  deviceTree:     ()      => get(DRIVERS+'tree'),
  updateDriver:   (id, d) => post(DRIVERS+'update/'+id, d),
  addDriver:      (id, d) => post(DRIVERS+'add/'+id, d),
  removeDriver:   (id)    => get(DRIVERS+'remove/'+id),

  deviceList:     ()      => get(DEVICES+'list'),
  deviceInfo:     (id)    => get(DEVICES+'info/'+id),
  deviceState:    (id)    => get(DEVICES+'state/' + id),
  allDeviceState: ()      => get(DEVICES+'state'),
  deviceConfig:   (id)    => get(DEVICES+'config/'+id),
  deviceChannel:  (id)    => get(DEVICES+'channels/'+id),
  deviceRecords:  (id)    => get(DEVICES+'records/'+id),
  addDevice:      (id, d) => post(DEVICES+'add/'+id, d),
  updateDevice:   (id, d) => post(DEVICES+'update/'+id, d),
  removeDevice:   (id)    => get(DEVICES+'remove/'+id),

  records:        (d)     => post(CHANNELS+'list', d),
  logRecords:     ()      => get(CHANNELS+'list/log'),
  record:         (id)    => get(CHANNELS+'get/'+id),
  setRecord:      (id, d) => post(CHANNELS+'set/'+id, d),
  writeChannel:   (id, d) => post(CHANNELS+'write/'+id, d),
  channelConfig:  (id)    => get(CHANNELS+'config/'+id),
  addChannel:     (id, d) => post(CHANNELS+'add/'+id, d),
  updateChannel:  (id, d) => post(CHANNELS+'update/'+id, d),
  removeChannel:  (id)    => post(CHANNELS+'remove/'+id),

  /* system */
  bundles:        ()      => get(HOST+'/system/console/bundles.json'),
  gogo:           (d)     => post(HOST+'/system/console/gogo'),

  /* Site Manager */
  tableList:      ()      => get(HOST+'/sm/db/tablelist'),
  tableStat:      ()      => get(HOST+'/sm/db/tablestat'),
  tableColumn:    (d)     => post(HOST+'/sm/db/tablecolumn', d),
  tableData:      (d)     => post(HOST+'/sm/db/tabledata', d),
  tableCreate:    (d)     => post(HOST+'/sm/db/tablecreate', d),
  tableDrop:      (d)     => post(HOST+'/sm/db/tabledrop', d),
  backup:         (id)    => get(HOST+'/sm/db/backup/'+id),
  restore:        (id, d) => post(HOST+'/sm/db/restore/'+id, d),
  folder:         (id)    => get(HOST+'/sm/db/folder/'+id),

  siteList:       (d)      => post(HOST+'/rest/site/list', d),
  siteInfo:       (id)    => get(HOST+'/rest/site/info/'+id),
  siteAdd:        (d)     => post(HOST+'/rest/site/add', d),
  siteRemove:     (d)     => post(HOST+'/rest/site/remove', d),
  siteUpdate:     (d)     => post(HOST+'/rest/site/update', d),
  sitePower:      (d)     => get(HOST+'/rest/site/power/' + d),

  historyList:    (d)     => post(HOST+'/rest/data/history/list', d),
  historyTable:   (d)     => post(HOST+'/rest/data/history/table', d),
  historyDates:   ()      => get(HOST+'/rest/data/history/dates'),

  productionDaily:(d)     => post(HOST+'/rest/production/daily', d),

  productionAll:  (d)     => post(HOST+'/rest/data/production', d),
  production:     (d)     => post(HOST+'/rest/data/production/list', d),
  productDates:   ()      => get(HOST+'/rest/data/production/dates'),
  productSites:   ()      => get(HOST+'/rest/data/production/sites'),
  today:          ()      => get(HOST+'/rest/data/today'),
  powerLatest:    ()      => get(HOST+'/rest/data/instant'),

  upload:         (url, params, file, cd) => httpUpload(encode(url, params), file, cd),

  jolokia:        (o)     => post(JOLOKIA, JSON.stringify(o)),
}



// WEBPACK FOOTER //
// ./src/lib/rest.js